<div class="start-center flex-row">
    <cb-loading-spinner class="flex"
                        [message]="data?.message"></cb-loading-spinner>
</div>
